import { Amount as BaseAmount } from '@/components/foundations';
import type { CategoryItem } from '@/components/charts';
import { CATEGORIES } from '@/mocks/financas';

export const CATEGORY_ITEMS: CategoryItem[] = CATEGORIES.map((c) => ({ id: c.id, name: c.name, color: c.color, value: c.total }));

export const Amount = ({ v }: { v: number }) => <BaseAmount value={v} />;
